module.exports = __webpack_public_path__ + "img/NCPI_200x120.ba8b16be.png";